import axios from "./axios"; // Import the centralized Axios instance
import prm from "./prm";

const state = {
  transaction_types: [],
};

const getters = {
  allTransactionTypes: (state) => state.transaction_types,
};

const actions = {
  async fetchTransactionTypes({ commit }, params = {}) {
    try {
      commit("resetTransactionTypes");
      const response = await axios.get("/transaction-type", { params: prm(params) });
      commit("setTransactionTypes", response.data);
      return response.data;
    } catch (error) {
      console.error("Failed to fetch transaction_types:", error);
    }
  },
  async createTransactionType({ commit }, transaction_type) {
    try {
      const response = await axios.post("/transaction-type", transaction_type);
      commit("addTransactionType", response.data);
      return response.data;
    } catch (error) {
      console.error("Failed to create transaction_type:", error);
      throw error;
    }
  },
  async fetchTransactionTypeById(_, id) {
    try {
      const response = await axios.get(`/transaction-type/${id}`);
      return response.data;
    } catch (error) {
      console.error("Failed to fetch transaction_type:", error);
      throw error;
    }
  },
  async updateTransactionType({ commit }, transaction_type) {
    try {
      const response = await axios.put(`/transaction-type/${transaction_type.id}`, transaction_type);
      commit("updateTransactionType", response.data);
    } catch (error) {
      console.error("Failed to update transaction_type:", error);
      throw error;
    }
  },
  async deleteTransactionTypeById({ commit }, id) {
    try {
      const response = await axios.delete(`/transaction-type/${id}`);
      commit("removeTransactionType", id);
      return response.data;
    } catch (error) {
      console.error("Failed to delete transaction_type:", error);
      throw error;
    }
  },
};

const mutations = {
  setTransactionTypes(state, transaction_types) {
    state.transaction_types = transaction_types.data; // Ensure this matches your API's response structure
  },
  addTransactionType(state, transaction_type) {
    state.transaction_types.push(transaction_type);
  },
  updateTransactionType(state, updatedTransactionType) {
    const index = state.transaction_types.findIndex(
      (transaction_type) => transaction_type.id === updatedTransactionType.id
    );
    if (index !== -1) {
      state.transaction_types.splice(index, 1, updatedTransactionType);
    }
  },
  removeTransactionType(state, id) {
    state.transaction_types = state.transaction_types.filter(
      (transaction_type) => transaction_type.id !== id
    );
  },
  resetTransactionTypes(state) {
    state.transaction_types = [];
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
